/* eslint-disable import/prefer-default-export */

export const isThirdPartyUrl = (to) => (
  typeof to === 'string'
  && (to.startsWith('https://') || to.startsWith('http://'))
  && !(to.includes('plasticity.ai') || to.includes('plasticityai.com'))
);
